/* JARDIN420 — porte 18 ans + révélations au scroll */
(function () {
  // Porte 18 ans
  var porte = document.getElementById('JardinPorte');
  if (porte) {
    var ok = false;
    try { ok = localStorage.getItem('jardin420-majeur') === 'oui'; } catch (e) {}
    if (window.location.search.indexOf('sansporte=1') !== -1) ok = true;
    if (ok) {
      porte.hidden = true;
    } else {
      document.documentElement.style.overflow = 'hidden';
      var btn = document.getElementById('JardinPorteOui');
      if (btn) btn.addEventListener('click', function () {
        try { localStorage.setItem('jardin420-majeur', 'oui'); localStorage.setItem('ageVerified', 'true'); } catch (e) {}
        porte.classList.add('jd-ouverte');
        document.documentElement.style.overflow = '';
        setTimeout(function () { porte.hidden = true; }, 1200);
      });
    }
  }
  // Révélations
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('jd-vu'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.jd-reveal').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.jd-reveal').forEach(function (el) { el.classList.add('jd-vu'); });
  }
})();

// ─── Correctif €/g WideBundle ───────────────────────────────────────────────
// L'étiquette « X € Le GR » de WideBundle vient d'un champ MANUEL de sa base,
// jamais resynchronisé quand les prix Shopify changent (constaté le 2026-08-25 :
// 7 produits affichaient un €/g faux). On recalcule ici le €/g depuis le prix
// total réel de la ligne (lui toujours juste) et on écrase l'étiquette.
// Aucune suppression de nœud — modification de texte uniquement (règle veilleur).
(function () {
  function grammes(txt) {
    var m = /([\d]+(?:[.,]\d+)?)\s*G/i.exec(txt || '');
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }
  function corriger() {
    document.querySelectorAll('.new-form-option').forEach(function (row) {
      var unitEl = row.querySelector('.wb_unit_price');
      var totalEl = row.querySelector('.first-price-WB');
      var titreEl = row.querySelector('.title-variant');
      if (!unitEl || !totalEl || !titreEl) return;
      var g = grammes(titreEl.textContent);
      var brut = totalEl.textContent || '';
      var m = /(\d+(?:[.,]\d+)?)/.exec(brut);
      if (!g || !m) return;
      var total = parseFloat(m[1].replace(',', '.'));
      if (!isFinite(total) || total <= 0) return;
      var sep = m[1].indexOf(',') !== -1 ? ',' : '.';
      var txt = brut.replace(m[1], (total / g).toFixed(2).replace('.', sep)).trim();
      if (unitEl.textContent !== txt) unitEl.textContent = txt;
      // le ratio interne de WB (recalcul au changement de variante) : le vrai est 1/g
      var priceP = row.querySelector('.price-new-form');
      if (priceP && priceP.getAttribute('data_offer_cr') !== String(1 / g)) {
        priceP.setAttribute('data_offer_cr', String(1 / g));
      }
    });
  }
  corriger();
  new MutationObserver(corriger).observe(document.documentElement, { childList: true, subtree: true });
})();
